import getSharingLink from '../selectors/getSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { mutator } from 'satcheljs';
import {
    updateSharingLinkFromSharingDialog,
    updateSharePointLinkPermission,
} from '../actions/internalActions';

mutator(updateSharingLinkFromSharingDialog, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    sharingLink.permissionLevel = actionMessage.sharingDialogResponse.permissionLevel;
});

mutator(updateSharePointLinkPermission, actionMessage => {
    const sharingLink: SharingLinkInfo = getSharingLink(actionMessage.linkId);
    sharingLink.permissionLevel = actionMessage.newPermission;
});
